module.exports = __webpack_public_path__ + "static/media/development.3cbb36b7.svg";